<template>
  <v-container>
    <h3 v-if="!this.password_selected">Let's get started. First, create an account or log in to one you already created.</h3>

    <v-btn v-if="!this.password_selected" color="primary" class="mt-3 login-button d-block" v-on:click="googleSignInClicked">Sign in with Google</v-btn>
    <v-btn v-if="!this.password_selected" color="primary" class="mt-3 login-button d-block" v-on:click="password_selected = true">Sign in with Email &amp; Password</v-btn>
    <div v-if="this.password_selected && !this.signup_selected">
      <v-form ref="signinform" v-model="form_valid" lazy-validation >
        <h3>Log in to existing account</h3>
        <v-text-field  label="Email" v-model.trim="email" :rules="required_field_rules"/>
        <v-text-field  type="password" label="Password" v-model.trim="password" :rules="required_field_rules"/>
        <v-btn color="secondary" class="mt-2" v-on:click="emailandpasswordClicked">Sign In</v-btn>
        <v-btn :text="true" color="primary" class="mt-3 d-block" v-on:click="signup_selected = true">Don't have an account? Sign up </v-btn>
        <v-btn :text="true" color="primary" class="mt-3 d-block" v-on:click="forgotPasswordClicked">Forgot password?</v-btn>
      </v-form>
    </div>
    <div v-if="this.signup_selected">
      <v-form ref="form" v-model="form_valid" lazy-validation >
        <h3>Create new account</h3>
        <v-text-field label="Email" v-model.trim="new_email" :rules="required_field_rules"/>
        <v-text-field  type="password" label="Password" v-model.trim="new_password" :rules="required_field_rules"/>
        <v-text-field  type="password" label="Confirm Password" v-model.trim="new_password2" :rules="required_field_rules"/>
        <v-btn :disabled="!form_valid" color="secondary" class="mt-2" v-on:click="createAccountClicked">Create</v-btn>
      </v-form>
    </div>
    <v-snackbar :color="snackbar.color || 'error'" v-model="snackbar.show" :timeout="4000" >
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show=false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<style scoped>
.login-button {
  min-width: 300px !important;
}
.login-button span {
  min-width: 300px !important;
}
</style>

<script>
import {firebase, db} from '@/firebaseInit.js'

export default {
  name: 'signin',
  data: () => ({
    email: null,
    password: null,
    new_email: null,
    new_password: null,
    new_password2: null,
    password_selected: false,
    signup_selected: false,
    form_valid: true,
    snackbar: { show: false, message: null, color: 'error' },
    required_field_rules: [ v => !!v || 'Required' ],
  }),
  methods: {
    emailandpasswordClicked() {
     if (!this.$refs.signinform.validate()) return;

      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {
        this.routeToOriginalRequest();
      }).catch(error => {
        this.errorSnackbar(error.message);
      });
    },

    forgotPasswordClicked() {
      this.$router.push({ name: 'ResetPassword' })
    },

    createAccountClicked() {
      if (!this.$refs.form.validate()) return;

      if (this.new_password == this.new_password2) {
        firebase.auth().createUserWithEmailAndPassword(this.new_email, this.new_password).then(async () => {
          var user = await firebase.getCurrentUser();
          if (!user) return;
          user.sendEmailVerification();
          this.routeToOriginalRequest();
        }).catch(error => {
          this.errorSnackbar(error.message);
        })
      } else {
        this.errorSnackbar("Passwords do not match");
      }
    },
    
    googleSignInClicked() {
      const provider = new firebase.auth.GoogleAuthProvider();
      this.doSignIn(provider, "Google");
    },

    facebookSignInClicked() {
      var provider = new firebase.auth.FacebookAuthProvider();
      this.doSignIn(provider, 'Facebook')
    },

    doSignIn(provider, methodName){
      firebase.auth().signInWithPopup(provider).then(() => {
        this.$analytics.logEvent("login", { method: methodName });
        this.routeToOriginalRequest();
      }).catch((error) => {
        this.errorSnackbar("Sign in failed. Try again or choose a different sign-in method.");

        const detailedError = {
          type: 'signin',
          error_code: error.code,
          message: error.message,
          date: firebase.firestore.FieldValue.serverTimestamp(),
          app_version: this.$appConfig.app.version,
        }
        if (error.email) {
          detailedError.email = error.email;
        }

        db.collection("errors").add(detailedError)
      });
    },

    routeToOriginalRequest() {
      var destinationRouteName = this.$route.query.dest;
      var foundRoute = this.$router.options.routes.find(r=> r.name == destinationRouteName);
      if(!foundRoute) {
        destinationRouteName = "map";
      }
      this.$router.push({ name: destinationRouteName })
    },

    errorSnackbar(errorMessage) {
      this.snackbar.show = true;
      this.snackbar.message = errorMessage;
      this.snackbar.color = 'error';
    },
  },
}
</script>